import { render, staticRenderFns } from "./SpartanBio.vue?vue&type=template&id=ee18f5e4&"
import script from "./SpartanBio.vue?vue&type=script&lang=js&"
export * from "./SpartanBio.vue?vue&type=script&lang=js&"
import style0 from "./SpartanBio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports